// extracted by css-extract-rspack-plugin
export default {"wrapper":"xDl3W","results":"f4kuP","name":"O6Shk","description":"eHl37","clause":"AoCwy","structure":"Dusrp","documentation":"i0oBJ"};